module.exports = __webpack_public_path__ + "img/intro-common-feature03.4bdf2ecc.jpg";